module.exports = __webpack_public_path__ + "assets/2-denver-sales-recruiting-agency.ef68f3aa.png";